import axios from "axios";
import { webApiAniosRecurrencia, webApiDescripcionRecurrencia, webApiRecurrencia } from "../routes/endpoints";

export const getAniosRecurrenciaData = async () => {
  const res = await axios.get(webApiAniosRecurrencia);
  const { data } = res;
  return data;
};

export const getRecurrenciaByYearData = async (year: string) => {
  const formData = new FormData();
  formData.append('anio', year);

  try {
      const res = await axios.post(webApiRecurrencia, formData, {
          headers: {
              'Content-Type': 'multipart/form-data',
          },
      });
      const { data } = res;
      return data;
  } catch (err) {
      console.warn(err)
  }
};

export const getDescripcionRecurrenciaData = async () => {
  const res = await axios.get(webApiDescripcionRecurrencia);
  const { data } = res;
  return data;
};
